import { SMALL_TEAM_WIDTH_BREAKPOINT } from '@capsicum/socios-core';
import { useCallback, useEffect, useRef, useState } from 'react';

type UseTeamsWidthCalculationProps = {
	getTeamsPerRow: (width: number) => number;
	resultsGap?: number;
	resultsPadding?: number;
};

export const useTeamsWidthCalculation = ({
	getTeamsPerRow,
	resultsGap = 0,
	resultsPadding = 0
}: UseTeamsWidthCalculationProps) => {
	const resultsContainerRef = useRef<HTMLDivElement>(null);
	const [resultsContainerWidth, setResultsContainerWidth] = useState(0);
	const teamsPerRow = getTeamsPerRow(resultsContainerWidth);

	const syncResultsContainerWidth = useCallback(() => {
		if (!resultsContainerRef.current) return;
		setResultsContainerWidth(resultsContainerRef.current.getBoundingClientRect().width);
	}, []);

	useEffect(() => {
		syncResultsContainerWidth();
		window.addEventListener('resize', syncResultsContainerWidth);

		return () => {
			window.removeEventListener('resize', syncResultsContainerWidth);
		};
	}, [syncResultsContainerWidth]);

	const teamWidth = Math.max(
		0,
		Math.floor((resultsContainerWidth - resultsGap * (teamsPerRow - 1) - resultsPadding * 2) / teamsPerRow)
	);

	return {
		elementRef: resultsContainerRef,
		isSmall: teamWidth < SMALL_TEAM_WIDTH_BREAKPOINT,
		teamWidth,
		width: resultsContainerWidth
	};
};
